import apiHotmartAI from '../apiHotmartAI'
import { HotmartAIEndpoints } from './constants'
import { CreateCompletionParams, CreateCompletionResponse, GetCompletionResponse } from './types'

class HotmartAIService {
  static async createCompletion(payload: CreateCompletionParams) {
    const { data } = await apiHotmartAI.post<CreateCompletionResponse>(
      HotmartAIEndpoints.createCompletion(),
      payload
    )

    return data
  }

  static async getCompletion(uuid: string) {
    const { data } = await apiHotmartAI.get<GetCompletionResponse>(
      HotmartAIEndpoints.getCompletion(uuid),
      {
        timeout: 5000 // 5 seconds
      }
    )

    return data
  }
}

export default HotmartAIService
